import { createModel } from "hox";
import { useState, useEffect } from "react";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/FmsTypes";
import { transPgToPagination } from "@/views/base/app/appModel";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { approvalService } from "./ApprovalService";
import { cloneDeep } from 'lodash';
import { UserFields, ApprovalShopFields, ApprovalFlowNodeFields, ApprovalFlowFields } from "./ApprovalTypes"

export const useApprovalModel = createModel(function () {
  const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

  const [addApplyDrawer, setAddApplyDrawer] = useState<boolean>(false);
  const [addNodeDrawer, setAddNodeDrawer] = useState<{ visible: boolean, node?: ApprovalFlowNodeFields }>({ visible: false });
  //查询条件
  const [searchParam, setSearchParam] = useState<UserFields>();
  //列表数据源
  const [dataSource, setDataSource] = useState<UserFields[]>([]);
  //列表数据源分页参数
  const [pgCfg, setPgCfg] = useState<TablePaginationConfig>();
  //门店选择
  const [shopTree, setShopTree] = useState<ApprovalShopFields[]>();
  const [selectedShop, setSelectedShop] = useState<ApprovalShopFields>();
  //流程节点
  const [flowNodes, setFlowNodes] = useState<ApprovalFlowNodeFields[]>([]);
  //选择的申请人
  const [applyUsers, setApplyUsers] = useState<UserFields[]>();
  //更新页选择的节点
  const [selectFlow, setSelectFlow] = useState<{ flowId: string, nodeIndex?: number }>();
  //更新页流程列表
  const [approvalFlows, setApprovalFlows] = useState<ApprovalFlowFields[]>([]);

  useEffect(() => {
    getApprovalShop();
  }, [])

  const getApprovalShop = async () => {
    let { retData } = await approvalService.getApprovalShop();
    setShopTree(retData);
  }

  const loadData = async (page: ISearchPage = initPgCfg, searchValue: any = searchParam) => {
    const searchParams = {
      ...defaultMdCmParam,
      ...searchValue,
      "simpleQuery": true,
      page: {
        pageSize: page?.pageSize ?? pgCfg?.pageSize ?? DEFAULT_PAGE_SIZE,
        pageNum: (page?.current || page?.pageNum) ?? pgCfg?.current ?? DEFAULT_FIRST_PAGE_NUM,
      }
    }
    let { retData } = await approvalService.getUser(searchParams);
    const { records, ...pg } = retData;
    setPgCfg(transPgToPagination(pg));
    setDataSource(records);
  }

  const getShopFlow = async (shopCode: string) => {
    await approvalService.getShopFlow(shopCode).then(res => {
      const approvalFlow = res.retData;
      setApprovalFlows(approvalFlow ?? []);
    })
  }

  const guid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  const clone = (data: any) => {
    return cloneDeep<any>(JSON.parse(JSON.stringify(data)));
  }


  return {
    initPgCfg, dataSource, loadData, guid, clone,
    pgCfg, setPgCfg,
    addApplyDrawer, setAddApplyDrawer,
    addNodeDrawer, setAddNodeDrawer,
    shopTree, getApprovalShop,
    selectedShop, setSelectedShop,
    flowNodes, setFlowNodes,
    selectFlow, setSelectFlow,
    applyUsers, setApplyUsers,
    approvalFlows, setApprovalFlows, getShopFlow,
  }

});